import React from 'react'
import {Chip, Paper} from '@mui/material'
import LockIcon from '@mui/icons-material/Lock'
import Typography from '@mui/material/Typography'
import {LoaderFunctionArgs, useLoaderData, useNavigate} from 'react-router-dom'
import {DataGrid, GridColDef} from '@mui/x-data-grid'
import axios from 'axios'

export interface EventTpSummary {
    id: number
    name: string
    start?: string | null
    end?: string | null
    max_tp?: number | null
    reclaimed_tp: number
    rolled_over_tp: number
    locked: boolean
    assigned_tp: number
    cma_event_id?: number | null
    cma_registration_id?: number | null
    cma_scrape_enabled: boolean
}

export const treasurePolicyLoader = async (_args: LoaderFunctionArgs): Promise<EventTpSummary[]> => {
    return axios.get('/treasure/events').then(({data}) => data)
}

const columns: GridColDef[] = [
    {field: 'name', headerName: 'Event', flex: 2, minWidth: 160},
    {field: 'locked', headerName: '', width: 90, sortable: false,
        renderCell: (params: any) => params.row.locked
            ? <Chip icon={<LockIcon/>} label="Locked" color="warning" size="small"/>
            : null
    },
    {
        field: 'start', headerName: 'Date', flex: 1, minWidth: 120,
        valueGetter: (params: any) => params.row.start
            ? new Date(params.row.start).toLocaleDateString() : '—'
    },
    {
        field: 'assigned_tp', headerName: 'Assigned TP', width: 120, align: 'center', headerAlign: 'center',
    },
    {
        field: 'remaining_tp', headerName: 'Remaining TP', width: 130, align: 'center', headerAlign: 'center',
        valueGetter: (params: any) => {
            const e = params.row
            if (e.max_tp == null && e.rolled_over_tp === 0) return '—'
            return (e.max_tp ?? 0) + e.rolled_over_tp - e.assigned_tp + e.reclaimed_tp
        }
    },
]

export function TreasurePolicy() {
    const events = useLoaderData() as EventTpSummary[]
    const navigate = useNavigate()

    return (
        <Paper elevation={2} sx={{p: 2}}>
            <Typography variant="h5" gutterBottom>Treasure Policy Manager</Typography>
            <DataGrid
                rows={events}
                columns={columns}
                autoHeight
                pageSizeOptions={[25, 50]}
                initialState={{pagination: {paginationModel: {pageSize: 25}}}}
                onRowClick={row => navigate(String(row.id))}
                sx={{cursor: 'pointer'}}
            />
        </Paper>
    )
}
